<!-- <app-loader *ngIf="isLoading()" /> -->
<div class="dialog-header">
    <h6>{{ isEditMode ? 'Edit Tariff' : 'Add Tariff' }}</h6>
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form [formGroup]="tariffForm" (ngSubmit)="onSubmit()">

  
    <div style="display: flex;justify-content: space-between;">
        <div style="display: flex; gap: 10px; ">
            <mat-form-field appearance="outline" style="width: 220px;">
                <mat-label>Service</mat-label>
                <input type="text" placeholder="Select Service" matInput formControlName="service"
                    [matAutocomplete]="autoService" (input)="filterServices()" [readonly]="isEditMode"
                    (blur)="onServiceBlur()" [matTooltip]="tariffForm.get('service')?.value || 'No data'"
                    matTooltipPosition="right" matTooltipShowDelay="300" />
                <mat-autocomplete #autoService="matAutocomplete"
                    (optionSelected)="onServiceSelected($event.option.value)">
                    <mat-option *ngFor="let service of filteredPortServices" [value]="service.name">
                        {{ service.name }}
                    </mat-option>
                </mat-autocomplete>

            </mat-form-field>
            <mat-form-field appearance="outline" class="purpose-field">
                <mat-label>Purpose</mat-label>
                <input type="text" matInput formControlName="purpose" [matAutocomplete]="autoPurpose" />
                <mat-autocomplete #autoPurpose="matAutocomplete">
                    <mat-option *ngFor="let purpose of purposes" [value]="purpose">
                        {{ purpose}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline" class="total-field">
                <mat-label>Service Total</mat-label>
                <input type="text" matInput formControlName="total"
                    [matTooltip]="tariffForm.get('total')?.value || 'No data'" matTooltipPosition="right"
                    matTooltipShowDelay="300" />
            </mat-form-field>
        </div>
        <div style="margin-top: -5px; display: flex; gap: 10px">
            <button mat-flat-button color="primary" class="add-subservice" (click)="addSubService()">
                <mat-icon>add</mat-icon> Add
                Subservice</button>
            <button mat-flat-button color="primary" class="add-Tariff" type="submit">
                {{ isEditMode ? 'Update Tariff' : 'Add Tariff' }}
            </button>
        </div>
    </div>

    <div style="width: 100%; display: flex; justify-content: space-between;">
        <mat-form-field class="input-text" appearance="outline">
            <!-- <mat-label>Info Message</mat-label> -->
            <textarea type="text" cdkTextareaAutosize #autoSize="cdkTextareaAutosize" placeholder="Enter info message"
                rows="2" matInput formControlName="info_msg"></textarea>
        </mat-form-field>
    </div>

    <div formArrayName="sub_services" class="scroll-subservices">
        <div *ngFor="let group of subServices.controls; let i = index" [formGroupName]="i" class="sub-service-section">
            <div class="sub-service-title" style="display: flex; gap: 5px; align-items: flex-start;">
                <div style="margin-top: 10px; width: 200px;">
                    <mat-form-field appearance="outline">
                        <mat-label>Sub-Service</mat-label>
                        <input type="text" matInput formControlName="sub_service" [matAutocomplete]="autoSubService"
                            (input)="filterSubServices(i)" [matTooltip]="group.get('sub_service')?.value || 'No data'"
                            matTooltipPosition="right" matTooltipShowDelay="300" />
                        <mat-autocomplete #autoSubService="matAutocomplete">
                            <mat-option *ngFor="let subService of filteredSubServices" [value]="subService.name">
                                {{ subService.name }}
                            </mat-option>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
                <div style="margin-top: 10px; width: 600px;">
                    <mat-form-field appearance="outline" style="width:600px;" class="formula-input">
                        <mat-label>Formula Result</mat-label>
                        <input matInput class="formula-input" formControlName="formula_result"
                            (input)="validateFormulaInput($event, i)"
                            [matTooltip]="group.get('formula_result')?.value || 'No data'" matTooltipPosition="right"
                            matTooltipShowDelay="300" />
                        <!-- Display validation error messages -->
                        <mat-error *ngIf="subServices.at(i).get('formula_result')?.hasError('invalidFormula')">
                            Only Basic Value, Tariff %, Movement terms and arithmetic operators allowed
                        </mat-error>
                        <mat-error *ngIf="subServices.at(i).get('formula_result')?.hasError('unbalancedBrackets')">
                            Please check the open and close brackets
                        </mat-error>
                        <mat-error
                            *ngIf="subServices.at(i).get('formula_result')?.hasError('invalidOperatorPlacement')">
                            Operators should be used in between the text
                        </mat-error>
                    </mat-form-field>
                </div>
               <div style="display: flex; align-items: center; gap: 3px; margin-top: 5px; margin-left: 5px;">
                    <div class="checkbox-row">
                        <mat-checkbox formControlName="optional" 
                            style="--mdc-checkbox-label-text-color: #ffffff; --mdc-checkbox-unselected-icon-color: #ffffff; color: #ffffff;">
                            Optional
                        </mat-checkbox>
                    </div>
                    <div class="checkbox-row">
                        <mat-checkbox formControlName="hide" 
                            style="--mdc-checkbox-label-text-color: #ffffff; --mdc-checkbox-unselected-icon-color: #ffffff; color: #ffffff;">
                            Hide
                        </mat-checkbox>
                    </div>
                    <button mat-icon-button class="delete-btn" type="button" (click)="removeSubService(i)"
                        [disabled]="subServices.length <= 1" style="color: #ffffff;">
                        <mat-icon class="delete-icon" fontSet="material-symbols-outlined"
                            [class.disabled]="subServices.length <= 1" style="color: #ffffff;">delete</mat-icon>
                    </button>
                </div>
            </div>


            <!-- <div class="base-value-text">
                <h6>Base value :</h6>
            </div> -->
            <div class="basic-value">
                <mat-form-field appearance="outline" class="movement-field">
                    <mat-label>Base value</mat-label>
                    <input type="text" matInput formControlName="basic_value" [matAutocomplete]="autoBasicValue"
                        (input)="onTypeaheadInput($event, 'basic_value')"
                        (keydown)="onTypeaheadKeydown($event, 'basic_value')" (blur)="validateBasicValue(i)"
                        [matTooltip]="group.get('basic_value')?.value || 'No data'" matTooltipPosition="right"
                        matTooltipShowDelay="300" />
                    <mat-autocomplete #autoBasicValue="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'basic_value', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="outline" class="movement-field">
                    <mat-label>Type</mat-label>
                    <input type="text" matInput formControlName="basic_value_function"
                        [matAutocomplete]="autoBasicValueFunction"
                        (input)="onTypeaheadInput($event, 'basic_value_function')"
                        (keydown)="onTypeaheadKeydown($event, 'basic_value_function')" (blur)="validateBasicValue(i)" />
                    <mat-autocomplete #autoBasicValueFunction="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'basic_value_function', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteFunctions" [value]="option.value">
                            {{ option.label}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="group.get('showBaseValueResultColumn')?.value" appearance="outline"
                    class="movement-field">
                    <mat-label>Service Fee</mat-label>
                    <input type="text" matInput formControlName="basic_value_tariff_service"
                        [matAutocomplete]="autoBasicValueTariffService"
                        (input)="onTypeaheadInput($event, 'basic_value_tariff_service')"
                        (keydown)="onTypeaheadKeydown($event, 'basic_value_tariff_service')"
                        (blur)="validateBasicValue(i)" />
                    <mat-autocomplete #autoBasicValueTariffService="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'basic_value_tariff_service', i)">
                        <mat-option *ngFor="let option of filteredAutocompletebasicValueTariffService"
                            [value]="option.value">
                            {{ option.label}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="group.get('showBaseValueResultColumn')?.value" appearance="outline"
                    class="movement-field">
                    <mat-label>Result Column</mat-label>
                    <input type="text" matInput formControlName="basic_value_result_column"
                        [matAutocomplete]="autoBasicValueResult"
                        (input)="onTypeaheadInput($event, 'basic_value_result_column')"
                        (keydown)="onTypeaheadKeydown($event, 'basic_value_result_column')"
                        (blur)="validateBasicValue(i)" />
                    <mat-autocomplete #autoBasicValueResult="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'basic_value_result_column', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteResultColumns" [value]="option.value">
                            {{ option.label}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <!-- <div class="base-value-text">
                <h6>Movement:</h6>
            </div> -->
            <div class="sub-service-container">
                <mat-form-field appearance="outline" class="movement-field">
                    <mat-label>Movement</mat-label>
                    <input type="text" matInput formControlName="movement" [matAutocomplete]="autoMovement"
                        (input)="onTypeaheadInput($event, 'movement')"
                        (keydown)="onTypeaheadKeydown($event, 'movement')"
                        [matTooltip]="group.get('movement')?.value || 'No data'" matTooltipPosition="right"
                        matTooltipShowDelay="300" />
                    <mat-autocomplete #autoMovement="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'movement', i)">
                        <mat-option *ngFor="let option of fileteredAutocompleteOptionsForMovement"
                            [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="outline" class="movement-field">
                    <mat-label>Type</mat-label>
                    <input type="text" matInput formControlName="movement_function"
                        [matAutocomplete]="autoMovementFunction" (input)="onTypeaheadInput($event, 'movement_function')"
                        (keydown)="onTypeaheadKeydown($event, 'movement_function')" />
                    <mat-autocomplete #autoMovementFunction="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'movement_function', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteFunctionsForMovement"
                            [value]="option.value">
                            {{ option.label}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="group.get('showMovementResultColumn')?.value"
                    class="movement-field">
                    <mat-label>Service Fee</mat-label>
                    <input type="text" matInput formControlName="movement_tariff_service"
                        [matAutocomplete]="autoMovementTariffService"
                        (input)="onTypeaheadInput($event, 'movement_tariff_service')"
                        (keydown)="onTypeaheadKeydown($event, 'movement_tariff_service')" />
                    <mat-autocomplete #autoMovementTariffService="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'movement_tariff_service', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteTariffServicesForMovement"
                            [value]="option.value">
                            {{ option.label}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="group.get('showMovementResultColumn')?.value" appearance="outline"
                    class="movement-field">
                    <mat-label>Result Column</mat-label>
                    <input type="text" matInput formControlName="movement_result_column"
                        [matAutocomplete]="autoMovementResult"
                        (input)="onTypeaheadInput($event, 'movement_result_column')"
                        (keydown)="onTypeaheadKeydown($event, 'movement_result_column')" />
                    <mat-autocomplete #autoMovementResult="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'movement_result_column', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteResultColumnsForMovement"
                            [value]="option.value">
                            {{ option.label}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

            </div>

            <!-- <div class="base-value-text">
                <h6>Tariff Percent :</h6>
            </div> -->

            <div class="basic-value">
                <mat-form-field appearance="outline" class="movement-field">
                    <mat-label>Tariff %</mat-label>
                    <input type="text" placeholder="Tariff %" rows="2" matInput formControlName="tariff"
                        [matAutocomplete]="autoTariff" (input)="onTypeaheadInput($event, 'tariff')"
                        (keydown)="onTypeaheadKeydown($event, 'tariff')"
                        [matTooltip]="group.get('tariff')?.value || 'No data'" matTooltipPosition="right"
                        matTooltipShowDelay="300" />
                    <mat-autocomplete #autoTariff="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'tariff', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteOptionsForTariff" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                    <!-- <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidFormat')">
                        Invalid format. Multiple colons not allowed.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidFirstPart')">
                        First part must be a valid vessel property or number.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidTariffService')">
                        Invalid tariff service.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidVslProperty')">
                        Must be a valid vessel property or number.
                    </mat-error> -->

                </mat-form-field>
                <mat-form-field appearance="outline" class="movement-field">
                    <mat-label>Type</mat-label>
                    <input type="text" rows="2" matInput formControlName="tariff_function"
                        [matAutocomplete]="autoFunction" (input)="onTypeaheadInput($event, 'tariff_function')"
                        (keydown)="onTypeaheadKeydown($event, 'tariff_function')" />
                    <mat-autocomplete #autoFunction="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'tariff_function', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteFunctionsForTariff"
                            [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                    <!-- <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidFormat')">
                        Invalid format. Multiple colons not allowed.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidFirstPart')">
                        First part must be a valid vessel property or number.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidTariffService')">
                        Invalid tariff service.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidVslProperty')">
                        Must be a valid vessel property or number.
                    </mat-error> -->
                    <!-- <mat-icon class="info-icon-textarea" matTooltip="{{tariffHelpText}}"
                        matTooltipPosition="right">info</mat-icon> -->

                </mat-form-field>
                <mat-form-field *ngIf="group.get('showTariffResultColumn')?.value " appearance="outline"
                    class="movement-field">
                    <mat-label>Service Fee</mat-label>
                    <input type="text" placeholder="Service Fee" rows="2" matInput formControlName="tariff_service"
                        [matAutocomplete]="autoTariffService" (input)="onTypeaheadInput($event, 'tariff_service')"
                        (keydown)="onTypeaheadKeydown($event, 'tariff_service')" />
                    <mat-autocomplete #autoTariffService="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'tariff_service', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteTariffServicesForTariff"
                            [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field *ngIf="group.get('showTariffResultColumn')?.value" appearance="outline"
                    class="movement-field">
                    <mat-label>Result Column</mat-label>
                    <input type="text" placeholder="Result Column" rows="2" matInput
                        formControlName="tariff_result_column" [matAutocomplete]="autoTariffResult"
                        (input)="onTypeaheadInput($event, 'tariff_result_column')"
                        (keydown)="onTypeaheadKeydown($event, 'tariff_result_column')" />
                    <mat-autocomplete #autoTariffResult="matAutocomplete"
                        (optionSelected)="onAutocompleteSelected($event.option.value, 'tariff_result_column', i)">
                        <mat-option *ngFor="let option of filteredAutocompleteResultColumnsForTariff"
                            [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-autocomplete>
                    <!-- <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidFormat')">
                        Invalid format. Multiple colons not allowed.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidFirstPart')">
                        First part must be a valid vessel property or number.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidTariffService')">
                        Invalid tariff service.
                    </mat-error>
                    <mat-error *ngIf="subServices.at(i).get('tariff')?.hasError('invalidVslProperty')">
                        Must be a valid vessel property or number.
                    </mat-error> -->
                    <!-- <mat-icon class="info-icon-textarea" matTooltip="{{tariffHelpText}}"
                        matTooltipPosition="right">info</mat-icon> -->
                </mat-form-field>
            </div>

        </div>
    </div>

</form>